import React from "react";
import Kpi from "@/components/admin/Kpi";

/**
 * Overview tab: read-only KPI grid built from GET /api/admin/stats.
 *
 * Extracted verbatim from src/pages/Admin.jsx during the code-quality pass:
 * markup, copy, data-testids and behaviour are unchanged - only the file
 * boundary moved.
 */
export default function AdminOverview({ stats }) {
  if (!stats) return null;
  return (
        <div className="mt-6 space-y-8" data-testid="admin-overview">
          <section>
            <h2 className="font-display text-xl font-bold text-[#1F2A2E]">Users</h2>
            <div className="mt-3 grid gap-3 sm:grid-cols-3 lg:grid-cols-7">
              <Kpi label="Total members" value={stats.users.total} />
              <Kpi label="New this week" value={stats.users.new_this_week} />
              <Kpi label="Active (24h)" value={stats.users.active_24h} tone="good" />
              <Kpi label="Sponsors" value={stats.users.sponsors} />
              <Kpi label="Sponsees" value={stats.users.sponsees} />
              <Kpi label="Suspended" value={stats.users.suspended} tone="warn" />
              <Kpi label="Banned" value={stats.users.banned} tone="danger" />
            </div>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-[#1F2A2E]">Community activity</h2>
            <div className="mt-3 grid gap-3 sm:grid-cols-3 lg:grid-cols-6">
              <Kpi label="Sponsor profiles" value={stats.sponsor_profiles.total} />
              <Kpi label="Accepting sponsees" value={stats.sponsor_profiles.accepting} tone="good" />
              <Kpi label="Paused profiles" value={stats.sponsor_profiles.paused} tone="warn" />
              <Kpi label="Pending requests" value={stats.activity.pending_requests} />
              <Kpi label="Active connections" value={stats.activity.accepted_connections} />
              <Kpi label="Messages sent" value={stats.activity.total_messages} />
            </div>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-[#1F2A2E]">Subscriptions</h2>
            <div className="mt-3 grid gap-3 sm:grid-cols-3 lg:grid-cols-6">
              <Kpi label="Weekly members" value={stats.subscriptions.weekly} />
              <Kpi label="Monthly members" value={stats.subscriptions.monthly} tone="good" />
              <Kpi label="Yearly members" value={stats.subscriptions.yearly} />
              <Kpi label="Canceled / expired" value={stats.subscriptions.canceled} tone="warn" />
              <Kpi label="Failed payments" value={stats.subscriptions.failed_payments} tone="danger" />
              <Kpi
                label="Revenue collected"
                value={`$${stats.subscriptions.revenue_collected.toFixed(2)}`}
                tone="good"
              />
            </div>
            <div className="mt-3 grid gap-3 sm:grid-cols-4">
              <Kpi label="Estimated MRR" value={`$${stats.subscriptions.estimated_mrr.toFixed(2)}`} />
              <Kpi label="Renewals collected" value={stats.subscriptions.renewals_collected ?? 0} tone="good" />
              <Kpi label="Past due" value={stats.subscriptions.past_due} tone="warn" />
              <Kpi label="Access passes granted" value={stats.subscriptions.free_passes_granted} />
            </div>
          </section>
        </div>
  );
}
